<template>
  <section class="explainer full-height" id="explainer">
    <div class="content">
      <div class="cols">
        <div class="col-left">
          <h2 class="why-against">
            <span>
              {{$t('explainer.why-against-ulfilters')}}:
            </span>
          </h2>
        </div>
        <div class="col-right">
          <div class="video-frame">
            <div class="video-button" v-on:click="toggleVideoSize">
              <div class="video-wat-question">{{$t('explainer.video-what-is-art-13-about')}}</div>
              <div class="thumbnail">
                <div class="thumbnail-size"></div>
                <div class="play-bt"></div>
              </div>
              <div class="video-wat-instruction">{{$t('explainer.video-watch')}}</div>
            </div>
            <div class="video-overlay" v-if="videoOverlay">
              <iframe :src="youtubeUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              <div class="video-overlay-bg" v-if="videoOverlay" v-on:click="toggleVideoSize"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="such-bad">
        <div class="bad-col">
          <h3><span class="bad">{{$t('explainer.bad')}}</span> {{$t('explainer.for-users')}}</h3>
          <div class="bad-content">
            <div class="piece">
              <h4>{{$t('explainer.censorship-machines')}}</h4>
              <p>{{$t('explainer.censorship-machines-text')}}</p>
            </div>
            <div class="piece">
              <h4>{{$t('explainer.fewer-creative-works')}}</h4>
              <p>{{$t('explainer.fewer-creative-works-text')}}</p>
            </div>
          </div>
        </div>

        <div class="bad-col">
          <h3><span class="bad">{{$t('explainer.bad')}}</span> {{$t('explainer.for-creators')}}</h3>
          <div class="bad-content">
            <div class="piece">
              <h4>{{$t('explainer.creativity-blocked')}}</h4>
              <p>{{$t('explainer.creativity-blocked-text')}}</p>
            </div>
            <div class="piece">
              <h4>{{$t('explainer.guilty-innocent')}}</h4>
              <p>{{$t('explainer.guilty-innocent-text')}}</p>
            </div>
          </div>
        </div>

        <div class="bad-col">
          <h3><span class="bad">{{$t('explainer.bad')}}</span> {{$t('explainer.for-innovation')}}</h3>
          <div class="bad-content">
            <div class="piece">
              <h4>{{$t('explainer.big-players')}}</h4>
              <p>{{$t('explainer.big-players-text')}}</p>
            </div>
            <div class="piece">
              <h4>{{$t('explainer.less-innovation')}}</h4>
              <p>{{$t('explainer.less-innovation-text')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="down">
        <svg
           xmlns:dc="http://purl.org/dc/elements/1.1/"
           xmlns:cc="http://creativecommons.org/ns#"
           xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
           xmlns:svg="http://www.w3.org/2000/svg"
           xmlns="http://www.w3.org/2000/svg"
           class="arrow-down"
           v-scroll-to="'#calling'"
           version="1.1"
           viewBox="0 0 40 40"
           height="40"
           width="40">
           <g transform="translate(0,-286.41665)">
             <g transform="translate(-275.51457,258.81956)">
               <path d="m 316.05823,32.531724 c -6.60773,5.284905 -13.4389,10.277011 -20.22245,15.33151 -6.84005,-4.982245 -13.55589,-10.121864 -20.22245,-15.33151 v 14.67045 l 20.22245,15.80303 20.22245,-15.80303 z"
                  style="fill:#fff;fill-opacity:1;stroke:#fff;stroke-width:0;stroke-miterlimit:10;stroke-dasharray:none" />
             </g>
           </g>
        </svg>
      </div>


    </div>

  </section>
</template>

<script>
export default {
  name: 'SectionExplainer',
  data () {
    return {
      videoOverlay: false,
    }
  },
  computed: {
    youtubeUrl () {
      if (this.$route.params.lang === 'de') {
        console.log('de')
        return 'https://www.youtube.com/embed/651XS0O39bc'
      }
      console.log('en')
      return 'https://www.youtube.com/embed/CyUh9wOp_Rw'
    }
  },
  methods: {
    toggleVideoSize () {
      this.videoOverlay = !this.videoOverlay
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang=scss scoped>
@import '@/assets/styles/_variable.scss';

.explainer {
  margin-bottom: 2em;
  background: #000;
  color: $main-bg;

  .why-against {
    color: $main-bg;
    font-size: 3.2em;
    max-width: 12em;
    @media (max-width:900px) {
      font-size: 2em;
      max-width: 100%;
    }
    line-height: 1.2;
    padding: 0 1em 0 0;
    margin: 1em 0 0 0;
  }
  .such-bad {
    display: flex;
    flex-direction: column;
    align-content: stretch;
    justify-content: space-between;
    .bad-col {
      border-top: 3px solid #333;
      display: flex;
      flex-direction: row;
      @media (max-width:900px) {
        flex-direction: column;
        border-top: 0;
      }
      flex-basis: 30%;
      padding: 1rem 0;
      h3 {
        color:  $main-bg;
        flex-grow: 1;
        flex-basis: 10%;
        margin: 0 0 0;
        padding-bottom: .3em;
        @media (max-width:900px) {
          color: $dark-text-color;
          background-color: $main-bg;
          padding: .3em;
          margin-bottom: .3em;
        }


        .bad {
          @media (max-width:900px) {
            font-size: 1.2em;
          }
          @media (min-width:901px) {
            display: block;
            font-size: 2.5em;
            line-height: .8em;
          }
          margin-left: -.07em;
        }
      }
      .bad-content {
        display: flex;
        @media (max-width:900px) {
          flex-direction: column;
        }
        flex-grow: 1;
        flex-basis: 60%;
        .piece {
          flex-grow: 1;
          flex-basis: 50%;
          padding-right: 2%;
          @media (max-width:900px) {
            margin: 2vh 0;
          }
          @media (min-width:901px) {
            margin-left: 3%;
          }
          h4 {
            color:  $main-bg;
            margin: 0 0 .2em;
            font-size: 1.2em;
            line-height: 1em;
          }
          p {
            margin: 0;
            font-size: .9em;
          }
        }
        line-height:1.2em;
      }
    }
  }
  .cols {
    display: flex;
    @media (max-width:900px) {
      flex-direction: column-reverse;
    }
    @media (min-width:901px) {
      align-items: flex-end;
      padding: 4vh 0;
      .col-left {
        flex-grow: 1;
        flex-basis: 75%;
      }
      .col-right {
        flex-grow: 1;
        flex-basis: 25%;
      }
    }
  }

    .video-frame {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      .video-button {
        display: flex;
        flex-direction: column;
        .video-wat-question {
          color: $main-bg;
          background: $dark-text-color;
          font-weight: 700;
          padding: .4em 0;
          text-align: center;
        }
        .video-wat-instruction {
          display: inline-block;
          padding: .4em 1em;
          color: $dark-text-color;
          background: $main-bg;
          font-weight: 700;
          cursor: pointer;
          text-align: center;
        }
      }
      .thumbnail {
        background-color: rgba(0,0,0,0.3);
        background-size: cover;
        background-position: center;
        background-image: url(../../static/img/preview.jpg);
        display: flex;
        justify-content: center;
        align-items: center;
        .thumbnail-size {
          padding-bottom: 50%;
        }
        .play-bt {
          background: rgba(0,0,0,.8);
          width: 30%;
          border-radius: 50%;
          position: relative;
          &:before {
            // triangle
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            margin: -20px -14px;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 35px solid #fff;
          }
          &:after {
            content: "";
            display: block;
            padding-bottom: 100%;
          }
        }
        cursor: pointer;
        &:hover {
          .play-bt {
            &:before {
              border-left-color: $main-bg;
            }
          }
        }

      }
    }

  .video-overlay {
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    iframe {
      z-index: 102;
      background-color: black;
      width: 80%;
      height: 80%;
      max-width: 1920px;
      max-height: 1080px;
    }
    .video-overlay-bg {
      z-index: 101;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.8);
      cursor: pointer;
    }
  }
  .down {
    text-align: center;
    margin-bottom: 1em;
    .arrow-down {
      cursor: pointer;
      transition: all .3s linear;
      opacity: .2;
      &:hover {
        opacity: .4;
      }
    }
  }
}
</style>
